export { PopupDirective } from './popup.directive';
export { L_PopupModule } from './popup.module';



// WEBPACK FOOTER //
// ./.tmp/popup/index.ts